<h3 mat-dialog-title class="center color-grey">
  {{ ('PROJECT.PROJECT_INFO.CHECKLIST.EDIT_ROW' | anessaTranslation: trigger) + ' ' + row.data.id  }}
</h3>
<form #rowForm mat-dialog-content>
  <div class="range-spacing">
    <div
      (mouseenter)="showClearMin = true"
      (mouseleave)="showClearMin = false"
      class="flex-container relative-container range-div">
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>{{'PROJECT.PROJECT_INFO.CHECKLIST.MIN' | anessaTranslation: trigger}}</mat-label>
        <input
          matInput
          [(ngModel)]="row.rangeMin"
          name="rangeMin"
          type="number">
      </mat-form-field>
      <p
        *ngIf="row.rangeMin && showClearMin"
        class="form-field-clear"
        (click)="row.rangeMin = null"
        anessaTranslation="PROJECT.COMMON.CLEAR">
      </p>
    </div>
    <div
      (mouseenter)="showClearMax = true"
      (mouseleave)="showClearMax = false"
      class="flex-container relative-container range-div">
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>{{'PROJECT.PROJECT_INFO.CHECKLIST.MAX' | anessaTranslation: trigger}}</mat-label>
        <input
          matInput
          [(ngModel)]="row.rangeMax"
          name="rangeMax"
          type="number">
      </mat-form-field>
      <p
        *ngIf="row.rangeMax && showClearMax"
        class="form-field-clear"
        (click)="row.rangeMax = null"
        anessaTranslation="PROJECT.COMMON.CLEAR">
      </p>
    </div>
    <div
      (mouseenter)="showClearFlag = true"
      (mouseleave)="showClearFlag = false"
      class="flex-container form-field-container flag-div">
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>{{'PROJECT.PROJECT_INFO.CHECKLIST.FLAG' | anessaTranslation: trigger}}</mat-label>
        <mat-select
          name="flag"
          [(ngModel)]="row.flag">
          <mat-select-trigger>
            <span
              class="coloured-circle"
              [ngStyle]="{'background-color': row.flag}">
            </span>
          </mat-select-trigger>
          <!-- Red -->
          <mat-option value="#FF0000">
            <span
              class="coloured-circle"
              [ngStyle]="{'background-color': '#FF0000'}">
            </span>
          </mat-option>
          <!-- Orange -->
          <mat-option value="#FF681F">
            <span
              class="coloured-circle"
              [ngStyle]="{'background-color': '#FF681F'}">
            </span>
          </mat-option>
          <!-- Yellow -->
          <mat-option value="#FFFF00">
            <span
              class="coloured-circle"
              [ngStyle]="{'background-color': '#FFFF00'}">
            </span>
          </mat-option>
          <!-- Green -->
          <mat-option value="#00FF00">
            <span
              class="coloured-circle"
              [ngStyle]="{'background-color': '#00FF00'}">
            </span>
          </mat-option>
          <!-- Blue -->
          <mat-option value="#0000FF">
            <span
              class="coloured-circle"
              [ngStyle]="{'background-color': '#0000FF'}">
            </span>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <p
        *ngIf="row.flag && showClearFlag"
        class="form-field-clear"
        (click)="row.flag = null"
        anessaTranslation="PROJECT.COMMON.CLEAR">
      </p>
    </div>
    <div class="check-align">
      <mat-checkbox name="anessaCheck" [(ngModel)]="row.anessaCheck">
        {{'PROJECT.PROJECT_INFO.CHECKLIST.CHECK_BY' | anessaTranslation: trigger}}
      </mat-checkbox><br>
      <mat-checkbox name="rowLock" [(ngModel)]="row.locked">
        locked
      </mat-checkbox>
    </div>
  </div>
</form>
<div>
  <button
    mat-button
    class="logic-btn"
    (click)="addLogic()"
    anessaTranslation="PROJECT.PROJECT_INFO.CHECKLIST.ADD_LOGIC">
  </button>
</div>
<mat-dialog-actions>
  <button
    mat-raised-button
    class="btn-green"
    (click)="onSave()"
    anessaTranslation="PROJECT.COMMON.SAVE">
  </button>
  <button
    mat-raised-button
    class="btn-red"
    color="warn"
    (click)="onCancel()"
    anessaTranslation="PROJECT.COMMON.CANCEL">
  </button>
</mat-dialog-actions>
